import { render, staticRenderFns } from "./OrignalFileViewer.vue?vue&type=template&id=9f58b6cc&scoped=true&"
import script from "./OrignalFileViewer.vue?vue&type=script&lang=js&"
export * from "./OrignalFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./OrignalFileViewer.vue?vue&type=style&index=0&id=9f58b6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58b6cc",
  null
  
)

export default component.exports